import { MenuItem, Pagination, Select, Stack, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

const staticOptions = [10, 25, 100];

const CustomPagination = (props) => {
  const {
    hidePerPage = false,
    count,
    page,
    handlePage,
    onPageChange,
    perPage,
    options,
  } = props;
  const classes = useStyles();
  return (
    <Stack className={classes.root}>
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
        }}
        display={hidePerPage ? "none" : ""}
      >
        <Typography sx={{ mr: 2, fontFamily: "inter" }}>
          Rows per page
        </Typography>
        <Select onChange={handlePage} value={perPage}>
          {options?.length > 0
            ? options.map((_el, index) => (
                <MenuItem key={index} value={_el}>
                  {_el}
                </MenuItem>
              ))
            : staticOptions.map((_el, index) => (
                <MenuItem key={index} value={_el}>
                  {_el}
                </MenuItem>
              ))}
        </Select>
      </Stack>
      <Pagination
        count={count}
        shape="rounded"
        page={page}
        onChange={onPageChange}
      />
    </Stack>
  );
};

export default CustomPagination;
